import { getTvObject, tv } from '@costar-ui/cosmos';

var dividerTvObject = getTvObject({
  variants: {
    light: {
      "true": ['bg-neutral-moderate/50'],
      "false": ['bg-neutral-moderate']
    },
    orientation: {
      vertical: ['border-r'],
      horizontal: ['border-t', 'w-full']
    },
    fullHeight: {
      "true": ['self-stretch', 'h-auto']
    },
    absolute: {
      "true": ['absolute bottom-0 left-0 w-full']
    }
  },
  compoundVariants: [
  // only set height on vertical divider if not fullHeight (flex)
  {
    orientation: 'vertical',
    fullHeight: false,
    className: 'h-e-1.0'
  }]
});
var dividerStyles = tv(dividerTvObject);

export { dividerStyles, dividerTvObject };
//# sourceMappingURL=divider.styles.esm.js.map
